import { RouteRecordRaw } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "weChatSource",
    name: "weChatSource",
    component: () => import("@/views/weChat-source/index.vue")
  }
];
export default routes;